import React from "react";
import {
  Button,
  Col,
  Form,
  FormGroup,
  Input,
  Label,
  Modal,
  ModalBody,
  ModalHeader,
  Row,
  Spinner,
} from "reactstrap";

const AddMerchantModal = ({
  addtoggle,
  addModal,
  handleSubmit,
  handleInputChange,
  formData,
  loading,
  loadingBtn,
  setShowPassword,
  showPassword,
  errors,
}) => {
  return (
    <div>
      <Modal isOpen={addModal} toggle={addtoggle}>
        <ModalHeader toggle={addtoggle}>Add Merchant Details</ModalHeader>
        <ModalBody>
          <Form onSubmit={handleSubmit}>
            <Row>
              <Col>
                <FormGroup>
                  <Label for="name">Merchant Name</Label>
                  <Input
                    type="text"
                    name="name"
                    id="name"
                    placeholder="Enter name"
                    value={formData.name}
                    onChange={handleInputChange}
                    required
                  />
                </FormGroup>
              </Col>
              <Col>
                <FormGroup>
                  <Label for="location">Location</Label>
                  <Input
                    type="text"
                    name="location"
                    id="location"
                    placeholder="Enter location"
                    value={formData.location}
                    onChange={handleInputChange}
                    required
                  />
                </FormGroup>
              </Col>
            </Row>

            <Row>
              <Col>
                <FormGroup>
                  <Label for="location">Status</Label>
                  <Input
                    type="select"
                    name="status"
                    id="status"
                    value={formData.status}
                    onChange={handleInputChange}
                    required
                  >
                    <option value="" selected disabled>
                      Select Status
                    </option>
                    <option value="Active">Active</option>
                    <option value="InActive">InActive</option>
                  </Input>
                </FormGroup>
              </Col>
              <Col>
                <FormGroup>
                  <Label for="location">Language</Label>
                  <Input
                    type="select"
                    name="language"
                    required
                    id="language"
                    value={formData.language}
                    onChange={handleInputChange}
                  >
                    <option value="" disabled selected>
                      Select Language
                    </option>
                    <option value="en">English</option>
                    <option value="ru">Russian</option>
                    <option value="fr">French</option>
                  </Input>
                </FormGroup>
              </Col>
            </Row>
            <Row className="d-flex flex-column justify-content-center align-items-center">
              <Col>
                {" "}
                <FormGroup>
                  <Label for="email">Email</Label>
                  <Input
                    required
                    type="email"
                    name="email"
                    id="email"
                    placeholder="Enter email"
                    value={formData.email}
                    onChange={handleInputChange}
                  />
                </FormGroup>
              </Col>
              <Col>
                {" "}
                <FormGroup>
                  <Label for="password">Password</Label>
                  <div style={{ position: "relative" }}>
                    <Input
                      required
                      type={showPassword ? "text" : "password"}
                      name="password"
                      id="password"
                      placeholder="Enter password"
                      value={formData.password}
                      onChange={handleInputChange}
                    />
                    <i
                      className={`fa ${
                        showPassword ? "fa-eye-slash" : "fa-eye"
                      }`}
                      onClick={() => setShowPassword(!showPassword)}
                      style={{
                        position: "absolute",
                        right: "10px",
                        top: "50%",
                        transform: "translateY(-50%)",
                        cursor: "pointer",
                        color: "#666",
                      }}
                    ></i>
                  </div>
                  <p
                    style={{
                      fontSize: "12px",
                      color: "red",
                      marginTop: "5px",
                    }}
                  >
                    {errors}
                  </p>
                </FormGroup>
              </Col>
            </Row>

            <div className="d-flex justify-content-end">
              <Button color="primary" disabled={loading || loadingBtn}>
                {loading || loadingBtn ? <Spinner size="sm" /> : "Save"}
              </Button>
            </div>
          </Form>
        </ModalBody>
      </Modal>
    </div>
  );
};

export default AddMerchantModal;
